export default {
	name: 'Convention.Registration.Store.Category.Map',
	path: 'convention/registration/store/:id/map',
	component: 'ConventionRegistrationStoreCategory',
	meta: {
		auth: true
	}
}